import type {ReactNode} from 'react';
import {tr} from '../i18n/idioma';
import {PestanasInventario} from './pestanas-inventario';

// Encabezado comun de Inventario (Consolidado, Mineros y Recolecciones): titulo,
// una sola linea de descripcion y "Herramientas" a la derecha, y debajo las
// pestanas. Asi las pestanas y el boton quedan al mismo nivel en las tres
// (Daniel, 13/10/2026).
export function EncabezadoInventario({descripcion, herramientas}: {descripcion: string; herramientas?: ReactNode}) {
  return (
    <>
      <div className="flex items-end justify-between gap-3">
        <div className="min-w-0">
          <h1 className="text-2xl font-semibold text-verde-oscuro">{tr('Inventario', 'Inventory')}</h1>
          <p className="truncate text-sm text-apagado" title={descripcion}>
            {descripcion}
          </p>
        </div>
        <div className="shrink-0">{herramientas}</div>
      </div>
      <PestanasInventario />
    </>
  );
}
